import axios from '../utilities/axios'

const STEAM_TICKET = 'steam_v1'

function activateGame(steamid, accessToken, userId, contentId, couponCode) {
  return axios.post('/api/v1/steam/content/activate', {
    steamid,
    accessToken,
    userId,
    contentId,
    couponCode,
  })
}

function buildLoginAuthUrl() {
  const baseUrl = process.env.RAZZLE_VALVE_STEAM_OAUTH_LOGIN_URL
  const clientId = process.env.RAZZLE_VALVE_STEAM_CLIENT_ID
  return `${baseUrl}?response_type=token&client_id=${clientId}`
}

// Verify if steamID is activated with User account
function verifyUserSteamTicket(ticket) {
  return axios.post('/api/v1/steam/ticket/verify', { ...ticket })
}

function saveUserTicket(payload) {
  return localStorage.setItem(STEAM_TICKET, payload)
}

function getUserTicket() {
  const ticket = localStorage.getItem(STEAM_TICKET)
  return JSON.parse(ticket) || null
}

function removeUserTicket() {
  return localStorage.removeItem(STEAM_TICKET)
}

function userSteamCheck(user, steamid, accessToken, captchaToken) {
  return axios.post('/api/v1/steam/user', { user, steamid, accessToken, captchaToken })
}

export default {
  activateGame,
  buildLoginAuthUrl,
  verifyUserSteamTicket,
  saveUserTicket,
  getUserTicket,
  removeUserTicket,
  userSteamCheck,
}
